import { useContext } from 'react';

import { InputNumber } from 'src/components/Inputs';
import { InputContext } from 'src/contexts/input.context';
import { mockFn } from 'src/tools/fn.tools';

interface Props {
  isCurrency?: boolean;
  isPercent?: boolean;
}

export function NumberInput({ isCurrency, isPercent }: Props) {
  const {
    classNames,
    value,
    onChange,
    onSubmit = mockFn,
    onDiscard = mockFn,
    isDisabled,
    isAutoFocus,
    onClick,
    customization,
    placeholder,
  } = useContext(InputContext);

  return (
    <div data-testid='input-renderer-number' className={classNames?.input}>
      <InputNumber
        className='w-100p'
        value={value}
        onChange={onChange}
        onSubmit={onSubmit}
        onDiscard={onDiscard}
        isDisabled={isDisabled}
        onClick={onClick}
        autoFocus={isAutoFocus}
        isCurrency={isCurrency}
        isPercent={isPercent}
        placeholder={placeholder}
        isXSmall={customization?.isXSmall}
      />
    </div>
  );
}
